import { z } from 'zod';

export const tinkoffInitSchema = z.object({
    Success: z.union([z.boolean(), z.literal(0), z.literal(1)]),
    PaymentURL: z.string().optional(),
    ErrorCode: z.string(),
    Message: z.string().optional(),
    OrderId: z.string().optional(),
    Status: z.string().optional(),
    PaymentId: z.string().optional(),
    Amount: z.number().optional(),
    TerminalKey: z.string().optional(),
});

export type TinkoffInitSchema = z.infer<typeof tinkoffInitSchema>;
